import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { SystemConfiguration } from 'src/app/models/SystemConfiguration';

@Injectable({
    providedIn: 'root'
})
export class SystemConfigurationApi extends Api<SystemConfiguration> {
}
